import { useCallback } from "react";
import { flyToCart } from "./flyToCart";

/**
 * `const fly = useFlyToCart(); fly(imageElement, imageUrl)` — the thumbnail arcs into the cart icon
 * and the badge pulses (only the pulse under reduced motion).
 */
export function useFlyToCart() {
  return useCallback((from: Element | null, imageUrl?: string) => flyToCart(from, imageUrl), []);
}
